module.exports = __webpack_public_path__ + "static/media/tk.24b3b9a3.svg";